import { render, staticRenderFns } from "./Notifs.vue?vue&type=template&id=15d77c58"
import script from "./Notifs.vue?vue&type=script&lang=js"
export * from "./Notifs.vue?vue&type=script&lang=js"
import style0 from "./Notifs.vue?vue&type=style&index=0&id=15d77c58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports